// extracted by mini-css-extract-plugin
export default {"failure":"uWo42OZoO4joKmR1g8ll"};